module.exports = __webpack_public_path__ + "static/media/chevron-gauche-cercle.76e4e3a2.png";